module.exports = "<nav class=\"\">\n  <div class=\"nav-links\">\n        <header id=\"header\">\n          <div class=\"header_top clearfix\">\n            <div class=\"container\">\n              <div class=\"logo\" id=\"Logo\">\n                <a href=\"/\"><img src=\"img/Bitmap.png\" style=\"width: px; height: px;\" alt=\"Lexpand Real Estate Lawyers\"></a>\n              </div>\n              <div class=\"contact-button\" id=\"contactButton\"><a href=\"https://lexpand.ca/contact-us\">Contact US</a></div>\n            </div>\n          </div>\n        </header>\n      </div>\n</nav>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/common/navbar/navbar.html
// module id = 419
// module chunks = 0